let map
let AMap
let mouseTool
export default {
  //设置地图
  setMap(_map) {
    map = _map
  },
  //获取地图
  getMap() {
    return map
  },
  //设置高德地图对象
  setAMap(_AMap) {
    AMap = _AMap
  },
  //获取高德地图对象
  getAMap() {
    return AMap
  },
  /*********************************************普通点操作 ************************************************/
  /**
   * 添加一个marker
   * @param param  json 对象，属性如下
   *        id     唯一 用于后续点位删除操作必传
   *        lonLat 必传，marker 经纬度
   *        offsetX,offsetY 默认值为（0,0）,单位是像素，代表偏移量，默认定位在html的（0,0）的位置
   *        icon  点位图标
   *        labelContent 文本内容 如果不需要不传或者传空
   *        labelOffsetX,labelOffsetY 文本的偏移
   *        labelDirection 文本标注方位 可选值：'top'|'right'|'bottom'|'left'|'center'，默认值: 'right'。
   *        clickEvent marker的点击事件，如果不需要注册点击就可以不传入
   *        clickEventExtData marker的点击事件返回的参数，如果不需要可以不传入.可以是一些自定义数据，比如点位详情
   * @returns {marker}
   */
  addMarker(param) {
    param = Object.assign(
      {
        id: '0',
        lonLat: [116.406315, 39.908775],
        icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
        offsetX: -13, //默认值为（0,0）,单位是像素，代表偏移量，默认定位在icon的（0,0）的位置
        offsetY: -30,
        labelContent: '',
        labelOffsetX: 0,
        labelOffsetY: 0,
        labelDirection: 'top',
        clickEvent: true,
        clickEventExtData: null,
      },
      param
    )
    console.log(param)
    let marker = new AMap.Marker({
      map: map, // map对象
      icon: param.icon,
      position: param.lonLat,
      offset: new AMap.Pixel(param.offsetX, param.offsetY),
      label: param.labelContent
        ? {
            content: param.labelContent,
            offset: [param.labelOffsetX, param.labelOffsetY], //new AMap.Pixel(param.label.offsetX, param.label.offsetY),
            direction: param.labelDirection,
          }
        : null,
      extData: param.clickEventExtData,
    })

    if (param.clickEvent) {
      marker.on('click', (e) => {
        param.clickEvent(e)
      })
    }

    return marker
  },

  /**
   * 批量加markers
   * @param Array  json list，属性如下
   *        id     唯一 用于后续点位删除操作必传
   *        lonLat 必传，marker 经纬度
   *        offsetX,offsetY 默认值为（0,0）,单位是像素，代表偏移量，默认定位在html的（0,0）的位置
   *        icon  点位图标
   *        labelContent 文本内容
   *        labelOffsetX,labelOffsetY 文本的偏移
   *        labelDirection 文本标注方位 可选值：'top'|'right'|'bottom'|'left'|'center'，默认值: 'right'。
   *        clickEvent marker的点击事件，如果不需要注册点击就可以不传入
   *        clickEventParam marker的点击事件返回的参数，如果不需要可以不传入
   * @returns {markers}
   */
  addMarkers(array) {
    let markers = []
    for (let i = 0, marker; i < array.length; i++) {
      let markerOptions = array[i]
      marker = this.addMarker(markerOptions)
      markers.push(marker)
    }
    return markers
  },

  /**
   * 批量删除markers
   * @param markers  json list，带map属性如点list
   */
  removeMarkers(markers) {
    map.remove(markers)
  },

  /**
   * 删除指定marker
   * @param marker  json带map属性如点
   */
  removeMarker(marker) {
    marker.setMap(null)
  },
  /*********************************************普通点操作 ************************************************/

  /**
   * 创建窗体
   * @param param  json 属性如下
   *    isCustom 是否自定义窗体。设为true时，信息窗体外框及内容完全按照content所设的值添加（默认为false，即在系统默认的信息窗体外框中显示content内容）
   *    autoMove: 是否自动调整窗体到视野内（当信息窗体超出视野范围时，通过该属性设置是否自动平移地图，使信息窗体完全显示）
   *    avoid: autoMove 为 true 时，自动平移到视野内后的上右下左的避让宽度。默认值： [20, 20, 20, 20]
   *    closeWhenClickMap:控制是否在鼠标点击地图后关闭信息窗体，默认false，鼠标点击地图后不关闭信息窗体
   *    content: 显示内容，可以是HTML要素字符串或者HTMLElement对象, 自定义窗体示例,
   *    size: 信息窗体尺寸（isCustom为true时，该属性无效）,
   *    anchor: 信息窗体锚点。默认值：'bottom-center'。可选值：'top-left'|'top-center'|'top-right'|'middle-left'|'center'|'middle-right'|'bottom-left'|'bottom-center'|'bottom-right',
   *    offsetX,offsetY,信息窗体显示位置偏移量。默认基准点为信息窗体的底部中心。默认值: [0, 0]
   * @returns {infoWindow}
   */
  createInfoWindow(param) {
    param = Object.assign(
      {
        isCustom: false,
        autoMove: false,
        avoid: [20, 20, 20, 20],
        closeWhenClickMap: false,
        content: '我是一个窗体',
        size: null,
        anchor: '',
        offsetX: 0,
        offsetY: 0,
      },
      param
    )
    let infoWindow = new AMap.InfoWindow({
      ...param,
      offset: [param.offsetX, param.offsetY],
    })
    return infoWindow
  },

  /**
   * 打开窗体
   * @param infoWindow  窗体对象
   * @param lnglat  经纬度[120,30]
   *
   */
  openInfoWindow(infoWindow, lnglat) {
    infoWindow.open(map, new AMap.LngLat(...lnglat))
  },

  /**
   * 关闭窗体
   * @param infoWindow  窗体对象
   *
   */
  closeInfoWindow(infoWindow) {
    infoWindow.close()
  },

  /**
   * @description:计算区域的中心点  
   * 参数[[113.049055,23.273062],[113.922468,23.605693],[114.230085,22.615453],[112.697493,22.954773],[112.851301,23.484833]]

   * @return {*}
   */

  calculateCenter(lnglatarr) {
    let total = lnglatarr.length
    let X = 0,
      Y = 0,
      Z = 0
    lnglatarr.map((item) => {
      let lng = (item[0] * Math.PI) / 180
      let lat = (item[1] * Math.PI) / 180
      let x, y, z
      x = Math.cos(lat) * Math.cos(lng)
      y = Math.cos(lat) * Math.sin(lng)
      z = Math.sin(lat)
      X += x
      Y += y
      Z += z
    })
    X = X / total
    Y = Y / total
    Z = Z / total
    let Lng = Math.atan2(Y, X)
    let Hyp = Math.sqrt(X * X + Y * Y)
    let Lat = Math.atan2(Z, Hyp)
    return new AMap.LngLat((Lng * 180) / Math.PI, (Lat * 180) / Math.PI)
  },
}
